import { Appointment } from "@elixir/types";
import { ReactComponent as ThermometerRegularIcon } from "../../../../assets/icons/font-awesome/thermometer-regular.svg";
import { onAddVitalsAction } from "../../../../utils/bridges/methods";
import { ChipWithTooltip } from "ui";

const AddVitalsAndLabResults = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  return (
    <ChipWithTooltip
      onClick={() => {
        onAddVitalsAction(apt);
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<ThermometerRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="Vitals"
      tooltipText="Add Vitals"
      type={type}
    />
  );
};

export default AddVitalsAndLabResults;
